<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <div v-if="device === 'mobile'">
      <sidebar class="sidebar-container zindex" />
    </div>
    <div class="main-container">
      <div v-if="device == 'mobile'" :class="{ 'fixed-header': fixedHeader }" class="mobileNavbar">
        <navbar />
      </div>
      <div
        v-if="device !== 'mobile'"
        style="width: 100%; height: 52px;display: flex;align-items: center;justify-content: space-between;flex-wrap: nowrap;"
        class="mainNav"
      >
        <div style="display: flex;align-items: center;">
          <logo v-if="device !== 'mobile'" :collapse="!sidebar.opened" />
          <sidebar class="sidebar" />
        </div>
        <!-- <div v-if="device !== 'mobile'" :class="{ 'fixed-header': fixedHeader }" class="mobileNavbar">

        </div> -->
        <navbar v-if="device !== 'mobile'" />
      </div>
      <app-main />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import Cookies from 'js-cookie'
import Logo from '../layout/components/Sidebar/Logo.vue'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    Logo
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  created() {
    if (this.device !== 'mobile') {
      Cookies.set('sidebarStatus', 1)
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.main-container {
  z-index: 2001 !important;
}

@media screen and (max-width: 760px) {
  .mobileNavbar {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 10000;
  }

  .sidebar {
    height: 100% !important;
    padding-left: 50px;
    margin-top: 5px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  }

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    background-color: #f6f8f9;
    // z-index: 80;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }
}

@media screen and (min-width: 770px) and (max-width: 1980px) {
  .mainNav {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #FFF;
    z-index: 999;
  }

  .sidebar {
    background-color: #fff;
    // padding-left: 50px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  }

  .app-wrapper {
    @include clearfix;
    position: relative;
    // height: 100%;
    width: 100%;
    background-color: #f6f8f9;
    margin-top: 55px !important;
    // z-index: 80;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 2002;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  //width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
